import { render, staticRenderFns } from "./Dictionary.vue?vue&type=template&id=6173a2cb&"
import script from "./Dictionary.vue?vue&type=script&lang=js&"
export * from "./Dictionary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports